let initialState = {
  userSkills: [],
  trajectorySkills: [],
  language: "",
  activeTheme: true,
  // myRegion: localStorage.getItem("region") || "",
  myRegion: { id: 0, name: "" },
  user: {},
  resizeWindow: 0,
  scrollDirection: null,
  isLandingWeb: false,
  config: null,
  collapse: true,
  flagSteps: false,
  scrollUp: false,
  showModalBuy: false,
  selectedTag: "",
  loadingGpt: false,
  loadingIndx: null,
  useFilterSkills: false,
  favoritesSum: 0,
  flagModalFavorite: false,
  flagModalFilter: false,
  vacancycData: [],
};
const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_USER_SKILLS":
      return {
        ...state,
        userSkills: action.payload,
      };
    case "SET_USER_TRAJECTORY":
      return {
        ...state,
        trajectorySkills: action.payload,
      };

    case "SET_USER_REGION":
      return {
        ...state,
        myRegion: action.payload,
      };
    case "CHANGE_LANGUAGE":
      return {
        ...state,
        language: action.payload,
      };
    case "CHANGE_THEME":
      return {
        ...state,
        activeTheme: action.payload,
      };
    case "SET_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "RESIZE_WINDOW":
      return {
        ...state,
        resizeWindow: action.payload,
      };
    case "SCROLL_DIRECTION":
      return {
        ...state,
        scrollDirection: action.payload,
      };
    case "SET_IS_LANDING_WEB":
      return {
        ...state,
        isLandingWeb: action.payload,
      };
    case "SET_CONFIG":
      return {
        ...state,
        config: action.payload,
      };
    case "SET_COLLAPSE":
      return {
        ...state,
        collapse: action.payload,
      };
    case "SET_FLAG_STEPS":
      return {
        ...state,
        flagSteps: action.payload,
      };
    case "SET_SCROLL_UP":
      return {
        ...state,
        scrollUp: action.payload,
      };
    case "SET_SHOW_GENERATE_BUY":
      return {
        ...state,
        showModalBuy: action.payload,
      };
    case "SET_SELECTED_TAG": //для скилсета
      return {
        ...state,
        selectedTag: action.payload,
      };
    case "SET_LOADING_GPT": //для скилсета
      return {
        ...state,
        loadingGpt: action.payload,
      };
    case "SET_LOADING_INDX": //для скилсета
      return {
        ...state,
        loadingIndx: action.payload,
      };
    case "SET_USE_FILTER_SKILLS": //для каталога и скилсета
      return {
        ...state,
        useFilterSkills: action.payload,
      };
    case "SET_FAVORITES_SUM": //для каталога и скилсета
      return {
        ...state,
        favoritesSum: action.payload,
      };
    case "SET_FLAG_FAVORITE": //для каталога и скилсета
      return {
        ...state,
        flagModalFavorite: action.payload,
      };
    case "SET_FLAG_FILTER": //для каталога и скилсета
      return {
        ...state,
        flagModalFilter: action.payload,
      };
    case "SET_VACANCYC_DATA": //для каталога и скилсета
      return {
        ...state,
        vacancycData: action.payload,
      };
    default:
      return state;
  }
};
export default Reducer;
